<template>
  <div class="unitAutoComplete flex-group">
    <AutoComplete
      :formData="formData"
      :tabindex="tabindex"
      store="Unit"
      :mapping="mapping"
      :removeOptionsLimit="true"
      placeholder="Select Unit"
      @update="changeUnit"
      ref="autoComplete"
    >
      Unit
    </AutoComplete>
    <UnitAutoCompleteAddEdit
      :unitData="unitData"
      :selectedCustomer="selectedCustomer"
      :tabindex="addTabindex"
      @added-unit="addedUnit"
      @unit-dialog-closed="handleUnitDialogClosed"
    />
  </div>
</template>
<script>
import UnitAutoCompleteAddEdit from './UnitAutoCompleteAddEdit.vue';
import Endpoint from '../../constants/api/endpoint/endpoint.constants';
import AutoComplete from '../shared/AutoComplete.vue';
import CustomerConstants from '../../constants/column-name/customer.column-name.constants';
import AjaxDataService from '../../../services/ajax.service';

export default {
  name: 'UnitAutoComplete',
  components: {
    UnitAutoCompleteAddEdit,
    AutoComplete
  },
  data() {
    return {
      getUnitEndpoint: Endpoint.Unit.getById,
      unitData: {}
    };
  },
  computed: {
    selectedCustomer() {
      return {
        [CustomerConstants.customerId.field]: this.formData.customerID,
        [CustomerConstants.customerCode.field]: this.formData.customerCode,
        [CustomerConstants.customerName.field]: this.formData.customerName,
        [CustomerConstants.customerThirdParty.field]: this.formData.billingThirdParty,
        [CustomerConstants.comments.field]: this.formData.customerInfoComments
      };
    }
  },
  methods: {
    changeUnit(unit) {
      this.getUnit(unit.unitID);
    },
    addedUnit(unit) {
      this.unitData = unit;
      this.$refs.autoComplete.selectAddedItem(unit);
      this.$emit('added-unit', unit);
    },
    async getUnit(unitID) {
      AjaxDataService.getData(this.getUnitEndpoint, { unitID }).then(({ data }) => (this.unitData = data));
    },
    handleUnitDialogClosed() {
      this.$emit('unit-modal-closed');
    }
  },
  watch: {
    formData: async function(newVal, oldVal) {
      if (newVal?.unitID == null || newVal?.unitID == undefined || newVal?.unitID == oldVal?.unitID) return;
      this.getUnit(newVal.unitID);
    }
  },
  props: {
    mapping: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    addTabindex: {
      type: Number
    },
    tabindex: {
      type: Number,
      default() {
        return 0;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.unitAutoComplete {
  align-items: center;
  display: flex;
  padding-right: 20px;
}

:deep(.autocomplete) {
  flex-grow: 1;
}
</style>
